// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import { generalConfigSelector, sessionConfigSelector, debugConfigSelector } from '../../../../../selectors/configSelectors';
import { headingSelector } from '../../../../../selectors/targetSelectors';
import { makePlaneEntitySelector } from '../../../../../selectors/planeSelectors';
import targetActions from '../../../../../actions/targetActions';
import { isActive } from '../../../../../utils/targetUtils';
import Plane from '../Plane';
import type { Props } from '../Plane';

type OwnProps = $ReadOnly<{|
    icao: string
|}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    const generalConfig = generalConfigSelector(state);
    const sessionConfig = sessionConfigSelector(state);
    const debugConfig = debugConfigSelector(state);
    const planeBuffer = makePlaneEntitySelector(props.icao)(state);

    const plane = planeBuffer && planeBuffer[0];

    return {
        planeBuffer: planeBuffer,
        heading: headingSelector(props.icao, planeBuffer)(state),
        isActive: Boolean(plane && isActive(plane.TimeOfTrackInformation, sessionConfig)),
        showLabel: Boolean(generalConfig.showLabels && generalConfig.labelType === 'draggable'),
        showTrails: generalConfig.showTrails,
        showDisconnected: debugConfig.showDisconnected
    };
};

const mapDispatchToProps = {
    selectTarget: targetActions.selectThunk
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Plane);